import { render, staticRenderFns } from "./StartupEditField.vue?vue&type=template&id=7bc3ba8d&scoped=true"
import script from "./StartupEditField.vue?vue&type=script&setup=true&lang=js"
export * from "./StartupEditField.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc3ba8d",
  null
  
)

export default component.exports